"use client";

import { useEffect, useState } from "react";

export default function CookieSettingsButton() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const handleClick = () => {
    if (isClient && window.UC_UI) {
      window.UC_UI.showSecondLayer();
    }
  };

  return (
    <button
      className="cursor-pointer hover:text-white transition-all duration-300 ease-in-out"
      onClick={handleClick}
    >
      Cookies
    </button>
  );
}
